module.exports = __webpack_public_path__ + "img/book.2f7a3e6b.svg";